import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SkeletonDashboard } from '@/components/loading/Skeleton';
import Header from '../home/components/Header';
import TabsCard from '@/components/Tabs';
import { useDiagnosisData } from './hooks/useDiagnosisData';
import { useTabControl } from './hooks/useTabControl';

// 动态导入 Tab 组件以提高性能
const OverviewTab = React.lazy(() => import('./tabs/OverviewTab'));
const HoldingsTab = React.lazy(() => import('./tabs/HoldingsTab'));
const TradingTab = React.lazy(() => import('./tabs/TradingTab'));
const RecommendationsTab = React.lazy(() => import('./tabs/RecommendationsTab'));
const ServicesRecommendationsTab = React.lazy(() => import('./tabs/ServicesRecommendationsTab'));

const DiagnosisPage = () => {
  const navigate = useNavigate();
  const { loading, refresh, handleQueryCopilotValue, polling22 } = useDiagnosisData();
  const { tabs, activeTab, setActiveTab } = useTabControl();

  const goBack = () => navigate(-1);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab />;
      case 'holdings':
        return <HoldingsTab />;
      case 'trading':
        return <TradingTab />;
      case 'recommendations':
        return <RecommendationsTab />;
      case 'servicesRecommendations':
        return <ServicesRecommendationsTab />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (activeTab === 'servicesRecommendations') {
      handleQueryCopilotValue(activeTab);
    } else {
      polling22.stopPolling();
    }
  }, [activeTab]);

  return (
    <div className="relative mx-auto flex h-screen flex-col overflow-hidden">
      <Header goBack={goBack} refresh={() => refresh(activeTab)}>
        <div className="text-lg font-semibold leading-none tracking-tight">持仓深度诊断</div>
      </Header>
      <TabsCard tabs={tabs} activeTab={activeTab} onChange={setActiveTab} type="underline" />
      <div
        className={`relative space-y-3 overflow-hidden px-4 ${
          loading ? 'opacity-50' : 'opacity-100'
        } transition-opacity duration-300`}
        id="ai-advisor-diagnosis-page"
      >
        <React.Suspense
          fallback={
            <div className="flex h-full w-full items-center justify-center">
              <SkeletonDashboard className="w-full" />
            </div>
          }
        >
          {renderTabContent()}
        </React.Suspense>
      </div>
    </div>
  );
};

export default DiagnosisPage;
